import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'az/20181225_155335.jpg' satisfies MediaPath
const a = 'az/20181126_110945.jpg' satisfies MediaPath
const b = 'az/20181127_140614.jpg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: '2018',
	name: '2018',
	excerpt: 'Field notes',
	tags: ['photography'],
	cover,
	order: 170,
}

export default function Year2018() {
	return (
		<>
			<p>A year in frames.</p>
			<Gallery
				items={[
					{ src: cover, alt: '2018' },
					{ src: a, alt: '2018' },
					{ src: b, alt: '2018' },
				]}
			/>
		</>
	)
}
